import React from "react";
import { Flex } from "antd";
import { SbiCardStyled, SbiLabelStyled, SbiValueStyled } from "./SbiCard.styles";

const CARD_BODY_STYLES = { body: { padding: "16px 20px" } };

const SbiCard = ({ label, value }) => (
  <SbiCardStyled styles={CARD_BODY_STYLES}>
    <Flex justify="space-between" align="center" gap={8}>
      <SbiLabelStyled>{label}</SbiLabelStyled>
      <SbiValueStyled>{value}</SbiValueStyled>
    </Flex>
  </SbiCardStyled>
);

export default SbiCard;
